import './NewJournal.scss'

import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Col, Container, Row } from 'react-bootstrap'
import { app } from '../../../../config'
import { navigateTo } from '../../../common/navigation'
import {
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL
} from '../../../common/helpers/Paths'
import {
  createJournalEntry,
  getUserJournals
} from '../../../common/api/Practices'
import EmojiPicker from '../JournalingContainer/EmojiPicker'
import JournalingContainer from '../JournalingContainer'
import JournalEntryHeading from '../JournalingContainer/JournalEntryHeading'
import JournalEntryContainer from '../JournalingContainer/JournalEntryContainer'
import JournalEntryButtons from '../JournalingContainer/JournalEntryButtons'

export default function NewJournal({
  setHeaderTitle,
  setReturnPath,
  setShowToast,
  setToastMessage
}) {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(true)
  const [journalData, setJournalData] = useState([])
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const [chosenEmoji, setChosenEmoji] = useState('😀')
  const [checkContent, setCheckContent] = useState(true)
  const [isButtonLoading, setIsButtonLoading] = useState(false)

  const content = useRef(null)

  const handleTextAreaChange = () =>
    setCheckContent(content.current?.value === '')

  const handleShowEmojiPicker = () => {
    setShowEmojiPicker(prevCheck => !prevCheck)
  }

  const onEmojiClick = (event, emojiObject) => {
    setChosenEmoji(emojiObject.emoji)
    setShowEmojiPicker(prevCheck => !prevCheck)
  }

  const handleUserJournals = () => {
    ;(async function getUserJournalsAsync() {
      const response = await getUserJournals()
      setJournalData(response || [])
      setIsLoading(false)
    })()
  }

  const handleClick = () => {
    setIsButtonLoading(true)

    const body = {
      journal_id: app.practices.journaling.free_entry_cat_id,
      journal_text: content.current.value,
      journal_emoji: chosenEmoji
    }

    const response = createJournalEntry(body)

    const message = response.error
      ? 'An error occurred. Please wait a moment and try again.'
      : 'Journal entry saved'

    setToastMessage(message)
    setShowToast(true)
    setIsButtonLoading(false)

    navigateTo(ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL, history)

    handleUserJournals()
  }

  useEffect(() => {
    setHeaderTitle('Journal')
    setReturnPath(ROUTE_ACTIVITIES_JOURNALING_ALL)

    if (journalData.length) return //return early

    handleUserJournals()
  }, [journalData, setHeaderTitle, setReturnPath])

  return (
    <JournalingContainer
      isLoading={isLoading}
      journalData={journalData}
      journalListHeading={'My Journals'}
      isButtonLoading={isButtonLoading}
    >
      <Container className='journaling-create-container'>
        <Row>
          <Col>
            <JournalEntryHeading
              classNames={'pt-5 pt-md-0 pb-2'}
              chosenEmoji={chosenEmoji}
              prompt={'New Entry'}
              handleShowEmojiPicker={handleShowEmojiPicker}
            />
          </Col>
        </Row>
        <Row className='position-relative mt-2'>
          <div className='emoji-container position-absolute end-0'>
            <EmojiPicker
              showEmojiPicker={showEmojiPicker}
              onEmojiClick={onEmojiClick}
            />
          </div>
          <Col>
            <JournalEntryContainer
              journalContent={content}
              handleTextAreaChange={handleTextAreaChange}
            />
          </Col>
        </Row>
        <Row>
          <Col className='mt-4'>
            <JournalEntryButtons
              handleClick={handleClick}
              checkContent={checkContent}
              isButtonLoading={isButtonLoading}
            >
              Save
            </JournalEntryButtons>
          </Col>
        </Row>
      </Container>
    </JournalingContainer>
  )
}
